import { useEffect, useState } from 'react';

interface BarraProgressoProps {
  /** Percentual de 0 a 100. */
  pct: number;
  /** Classe de cor do preenchimento (token). */
  cor?: string;
  /** Atraso antes de animar, em ms. */
  atraso?: number;
}

// Barra que anima ao entrar (600 ms, ease-out). Sem rolagem lateral, sempre fluida.
export default function BarraProgresso({
  pct,
  cor = 'bg-primary-500',
  atraso = 60,
}: BarraProgressoProps) {
  const [largura, setLargura] = useState(0);

  useEffect(() => {
    const alvo = Math.max(0, Math.min(100, pct));
    const t = setTimeout(() => setLargura(alvo), atraso);
    return () => clearTimeout(t);
  }, [pct, atraso]);

  return (
    <div className="rel-barra h-2.5 w-full overflow-hidden rounded-full bg-background-100">
      <div
        className={`h-full rounded-full transition-[width] duration-[600ms] ease-out motion-reduce:transition-none ${cor}`}
        style={{ width: `${largura}%` }}
      />
    </div>
  );
}